import React, { useState } from 'react';
import Home from '../Home';

// --- REACT COMPONENT ---
// I've refactored the component to use Tailwind CSS for styling,
// which resolves the previous compilation error.
const FaqItem = ({ q, a }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div 
      className="border border-gray-300 rounded-lg p-4 bg-white cursor-pointer transition-shadow duration-300 hover:shadow-md"
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="font-bold text-gray-800 flex justify-between items-center">
        <span>{q}</span>
        <span className="text-xl">{isOpen ? '-' : '+'}</span>
      </div>
      {isOpen && (
        <div className="mt-4 pt-4 border-t border-gray-200 text-gray-600">
          {a}
        </div>
      )}
    </div>
  );
}


const WebAppsDevelopment = () => {
  // Data for the component cards to avoid repetition

    const faqs = [
    { q: "What is Web App development, and why is it important?", a: "Web app development is the process of creating application programs that reside on remote servers and are delivered to the user's device over the Internet. It's important for reaching a broad audience on any device." },
    { q: "How long does it take to develop a web app?", a: "The timeline can vary greatly depending on complexity, features, and team size, ranging from a few weeks for simple apps to several months or more for complex enterprise-level applications." },
    { q: "What's the difference between a web app and a website?", a: "A website is primarily informational, while a web app is interactive and performs specific tasks for the user. Web apps are dynamic and have more complex functionality." },
    { q: "What is the best technology stack for my project?", a: "The best stack depends on your project's specific requirements, including scalability, performance needs, and developer expertise. We help you choose the right technologies." },
    { q: "How can I ensure the security of my web app and user data?", a: "We implement security best practices like data encryption, secure authentication, regular security audits, and compliance with data protection regulations." },
    { q: "What are the stages involved in the web app development process?", a: "The typical stages include planning, UI/UX design, development (front-end and back-end), testing, deployment, and ongoing maintenance and support." }
  ];

  const componentData = [
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 256 256"><path d="M244.2,88.2,147.8,12.2a15.9,15.9,0,0,0-23.6,0L28.2,88.2a16,16,0,0,0-4.4,13.7l16,128a16,16,0,0,0,16,14.1H198.2a16,16,0,0,0,16-14.1l16-128A16,16,0,0,0,244.2,88.2ZM128,24,224,96l-14.1,112H46.1L32,96Zm0,152a36,36,0,1,1,36-36A36,36,0,0,1,128,176Zm0-56a20,20,0,1,0,20,20A20,20,0,0,0,128,120Z"></path></svg>,
      title: 'Front-End Development',
      features: [
        'User interface design',
        'HTML, CSS, JavaScript usage',
        'User experience (UX) optimization',
        'Interaction and animations'
      ]
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 256 256"><path d="M208,80H48a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,80H48V96H208v64ZM68,128a12,12,0,1,1-12-12A12,12,0,0,1,68,128Z"></path></svg>,
      title: 'Back-End Development',
      features: [
        'Server architecture setup',
        'Data storage and retrieval',
        'Authentication and security',
        'Business logic implementation'
      ]
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,16V80H48V48Zm-12,88a12,12,0,1,1-12-12A12,12,0,0,1,196,136Zm-52,0a12,12,0,1,1-12-12A12,12,0,0,1,144,136ZM92,136a12,12,0,1,1-12-12A12,12,0,0,1,92,136Zm-44,56V160H208v32Z"></path></svg>,
      title: 'Database Management',
      features: [
        'Database structure design',
        'Data organization and storage',
        'Data integrity and security',
        'Backup and maintenance'
      ]
    }
  ];

  // Data for the info sections
  const infoData = [
    {
      image: "https://placehold.co/600x400/2a2a3a/ffffff?text=Expertise",
      alt: "Team collaborating on a project",
      title: "Expertise and Innovation",
      text: "SRK Softwares stands out for its unmatched expertise and innovative solutions. Our team has years of experience in the industry, ensuring your project is in the hands of seasoned professionals. We are committed to delivering high-quality web applications that meet your unique business objectives."
    },
    {
      image: "https://placehold.co/600x400/3a3a4a/ffffff?text=User-Centric",
      alt: "Designer sketching user interfaces",
      title: "User-Centric Design",
      text: "We understand that a successful web app is built around user experiences. Our design philosophy revolves around the end-user. We gain insights into their preferences and behaviors, which allows us to create intuitive, user-friendly applications that are both visually appealing and easy to navigate."
    },
    {
      image: "https://placehold.co/600x400/4a4a5a/ffffff?text=Partnership",
      alt: "Business handshake",
      title: "Partnership and Support",
      text: "We believe in building a long-term partnership, not just a one-time service. We believe in a collaborative approach, working with you every step of the way. Our agile methodologies ensure flexibility in adapting to your evolving needs and delivering on time and within budget."
    }
  ];

  return (
    <Home>
    <div className="bg-[#121212] text-[#E0E0E0] font-['Roboto',_sans-serif] w-full overflow-x-hidden">
      {/* Header Section */}
      <header 
        className="min-h-[80vh] flex flex-col justify-center items-center text-center p-8 relative bg-cover bg-center"
        style={{backgroundImage: "linear-gradient(rgba(20, 20, 30, 0.85), rgba(20, 20, 30, 0.85)), url('https://placehold.co/1920x1080/1a1a2e/ffffff?text=SRK+Softwares')"}}
      >
        <div className="max-w-4xl z-10">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-4" style={{textShadow: '2px 2px 8px rgba(0,0,0,0.5)'}}>
            Super Engaging Web App Development by <span className="text-yellow-400">SRK Softwares</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
            SRK Softwares is a premier web application development company that builds robust, scalable, and secure web apps to help you achieve your business objectives. We embrace the latest technologies to deliver outstanding results.
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            <a href="#" className="bg-blue-600 text-white py-3 px-6 rounded-lg font-bold shadow-lg shadow-blue-600/40 transform transition-all duration-300 hover:bg-blue-700 hover:-translate-y-1 hover:shadow-xl">
              Need help with Best SEO?
            </a>
            <a href="#" className="bg-yellow-400 text-gray-900 py-3 px-6 rounded-lg font-bold shadow-lg shadow-yellow-400/40 transform transition-all duration-300 hover:bg-yellow-500 hover:-translate-y-1 hover:shadow-xl">
              GET A QUOTE
            </a>
          </div>
        </div>
      </header>

      <main>
        {/* Components Section */}
        <section className="py-16 px-8 max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center mb-12 relative pb-4">
            Major Components of Web App Development
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-blue-600 to-yellow-400 rounded-full"></span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {componentData.map((card, index) => (
              <div key={index} className="bg-[#1E1E1E] rounded-xl p-8 text-center border border-gray-700 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-blue-600/20">
                <div className="text-blue-500 mb-6 flex justify-center">
                  {card.icon}
                </div>
                <h3 className="text-2xl font-bold mb-6 text-yellow-400">{card.title}</h3>
                <a href="#" className="inline-block bg-gray-800 text-gray-200 py-2 px-5 rounded-lg border border-gray-600 transition-colors duration-300 hover:bg-blue-600 hover:text-white hover:border-blue-600 mb-6">
                  Connect Us
                </a>
                <ul className="text-left space-y-3">
                  {card.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-center text-gray-300">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="text-blue-500 mr-3 flex-shrink-0" viewBox="0 0 256 256"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path></svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Info Sections */}
        <div className="space-y-16 md:space-y-24">
          {infoData.map((info, index) => (
            <section key={index} className="py-16 px-8 max-w-7xl mx-auto">
              <div className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center ${index % 2 !== 0 ? 'md:grid-flow-col-dense' : ''}`}>
                <div className={index % 2 !== 0 ? 'md:col-start-2' : ''}>
                  <img src={info.image} alt={info.alt} className="w-full h-auto rounded-xl object-cover shadow-lg" />
                </div>
                <div className={index % 2 !== 0 ? 'md:col-start-1' : ''}>
                  <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">{info.title}</h3>
                  <p className="text-lg text-gray-300">{info.text}</p>
                </div>
              </div>
            </section>
          ))}
        </div>
      </main>
          <div className="bg-white text-gray-800 font-['Roboto',_sans-serif] w-full overflow-x-hidden">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <section className="py-16 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            What Web App Development Strategies Propel Us as the Leading Company in Patna?
          </h1>
          <p className="max-w-3xl mx-auto text-gray-600 text-lg">
            At SRK Softwares, our approach isn't just about building web apps; it's about engineering digital experiences that elevate your business expression. We adopt a data-driven methodology, presenting optimal strategies that not only draw in visitors but also convert them into loyal customers.
          </p>
        </section>

        <section className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Why Web App Development Matters</h2>
              <p className="text-gray-600">
                Web apps are dynamic, accessible via browsers, and essential for modern business. They offer a seamless User Experience, crafting intuitive interfaces for satisfaction. Our designs are responsive, ensuring a perfect experience on any device, and we provide Real-Time Updates, keeping users informed and connected.
              </p>
            </div>
            <img src="https://placehold.co/600x400/e2e8f0/334155?text=Development+Matters" alt="Developer working on code" className="rounded-lg shadow-lg w-full" />
          </div>
        </section>
        
        <section className="py-8">
            <div className="bg-red-500 text-white p-6 rounded-lg shadow-md flex flex-col sm:flex-row justify-between items-center text-center sm:text-left">
                <span className="mb-4 sm:mb-0">Dive deeper into the details and extend the fields of SEO with Voice Recorded Audio Reports.</span>
                <a href="#" className="bg-white text-red-500 font-bold py-2 px-6 rounded-md transition duration-300 hover:bg-gray-100 hover:shadow-lg transform hover:-translate-y-0.5">
                    Yes, I agree
                </a>
            </div>
        </section>

        <section className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <img src="https://placehold.co/600x400/334155/e2e8f0?text=Our+Approach" alt="Digital strategy diagram" className="rounded-lg shadow-lg w-full md:order-last" />
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">A Comprehensive Approach</h2>
              <p className="text-gray-600 mb-6">
                At SRK Softwares, we follow a comprehensive approach to web app development to ensure your project’s success:
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                    <span className="text-red-500 font-bold text-xl mr-3 mt-1">✓</span>
                    <div><strong className="font-bold text-gray-800">Understanding Your Vision:</strong> We begin by understanding your business goals and the scope of the project.</div>
                </li>
                <li className="flex items-start">
                    <span className="text-red-500 font-bold text-xl mr-3 mt-1">✓</span>
                    <div><strong className="font-bold text-gray-800">Strategic Planning:</strong> Our team collaborates to create a detailed plan, wireframes, and prototypes.</div>
                </li>
                <li className="flex items-start">
                    <span className="text-red-500 font-bold text-xl mr-3 mt-1">✓</span>
                    <div><strong className="font-bold text-gray-800">Development and Testing:</strong> Using the latest technologies and coding practices, we ensure a high-quality, bug-free product.</div>
                </li>
                 <li className="flex items-start">
                    <span className="text-red-500 font-bold text-xl mr-3 mt-1">✓</span>
                    <div><strong className="font-bold text-gray-800">Deployment:</strong> We deploy your web app on secure servers, ensuring optimal performance, security, and scalability.</div>
                </li>
                 <li className="flex items-start">
                    <span className="text-red-500 font-bold text-xl mr-3 mt-1">✓</span>
                    <div><strong className="font-bold text-gray-800">Maintenance and Support:</strong> Our commitment doesn’t end with deployment. We provide ongoing maintenance, updates, and support.</div>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-50 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-black text-center text-gray-900 mb-8">Frequently Asked Questions</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {faqs.map((faq, index) => <FaqItem key={index} q={faq.q} a={faq.a} />)}
            </div>
          </div>
        </section>

      </main>

      <footer className="bg-gray-800 text-white mt-16">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-black mb-4">Follow Us</h2>
            <p className="text-gray-300 max-w-xl mx-auto mb-8">
                Stay connected with us on Facebook and LinkedIn for the latest updates, insights, and industry news.
            </p>
            <div className="flex justify-center gap-4">
                <a href="#" className="bg-yellow-500 text-gray-900 font-bold py-3 px-8 rounded-md transition duration-300 hover:bg-yellow-400 hover:shadow-lg">Facebook</a>
                <a href="#" className="bg-yellow-500 text-gray-900 font-bold py-3 px-8 rounded-md transition duration-300 hover:bg-yellow-400 hover:shadow-lg">LinkedIn</a>
            </div>
        </div>
      </footer>
    </div>
    </div>
    </Home>
  );
};

export default WebAppsDevelopment;


